import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../../../logics/api_config";
import {useAuth} from "../../../../../../../../utils/contexts/auth-context";

export type WeightByYearItem = { year: number; total_weight: number };

const useApiGetWeightByYear = (): UseQueryResult<WeightByYearItem[], CustomAxiosError> => {
    const {selectedCompany} = useAuth();
    const {get} = useApiCalls();

    async function doGet(companyToken: string | undefined): Promise<WeightByYearItem[]> {
        if (!companyToken) return [];

        const url = `/api/company/${companyToken}/tannery_production/order_schedule/tannery_dyeing/weight_by_year/`;
        const response = await get(url);

        return response.data as WeightByYearItem[];
    }

    return useQuery({
        queryKey: ['useApiGetWeightByYear', selectedCompany?.company_token],
        queryFn: () => doGet(selectedCompany?.company_token),
        enabled: !!selectedCompany?.company_token,
    });
};

export default useApiGetWeightByYear;